import React from "react";
import layoutStyle from "./layoutStyle";
import NavigationBar from "../../components/Navigation/NavigationBar/NavigationBar";
import Footer from "../../components/Footer/Footer";
import useMediaQuery from "@mui/material/useMediaQuery";
import NavigationBarMobile from "../../components/Navigation/NavigationBar/Mobile/NavigationBarMobile";
import backgroundStyling from "../../services/layoutService";
import ReleaseInfo from "../../components/ReleaseInfo/ReleaseInfo";
import ScrollTopButton from "../../components/Button/ScrollTopButton";
import { useCustomer } from "../../provider/Customer/CustomerProvider";
import { Box, Theme } from "@mui/material";
import { useFlexServiceLayoutForCustomer } from "../../services/advocardService";

type LayoutProps = {
  minimal?: boolean;
  clickableLogo?: boolean;
  backgroundType?: "homepage" | "serviceworld" | "landingpage";
  children?: React.ReactNode;
  withScrollToTopButton?: boolean;
};

export default function Layout({ minimal = false, clickableLogo = true, backgroundType, children, withScrollToTopButton = true }: LayoutProps) {
  const { customer } = useCustomer();

  const isDesktopView = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
  const hideNavigation = useFlexServiceLayoutForCustomer(customer);

  if (isDesktopView) {
    return (
      <>
        <ReleaseInfo />
        <Box sx={layoutStyle.pageContainer}>
          <Box sx={[layoutStyle.content, backgroundType ? backgroundStyling.desktop[backgroundType] : {}]}>
            <NavigationBar minimal={minimal} clickableLogo={clickableLogo} hideMainNavigation={hideNavigation} />
            <Box sx={layoutStyle.childrenContainer} id={"main-content"}>
              {children}
            </Box>
            <Footer hideProductLinks={hideNavigation} />
          </Box>
        </Box>
        {withScrollToTopButton && <ScrollTopButton />}
      </>
    );
  }

  return (
    <>
      <ReleaseInfo />
      <Box sx={layoutStyle.pageContainer}>
        <Box sx={[layoutStyle.content, backgroundType ? backgroundStyling.mobile[backgroundType] : {}]}>
          <NavigationBarMobile minimal={minimal} clickableLogo={clickableLogo} hideMainNavigation={hideNavigation} />
          <Box sx={layoutStyle.childrenContainer}>{children}</Box>
          <Footer hideProductLinks={hideNavigation} />
        </Box>
      </Box>
      {withScrollToTopButton && <ScrollTopButton />}
    </>
  );
}
